import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { darken } from '@savgroup-front-common/primitive/helpers/cssColor';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { NEED_HELP_POSITION_TYPES } from './NeedHelp.types';

interface NeedHelpPropsContainer {
  $position: string;
}

export const $NeedHelpButton = styled.button`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;

  & svg {
    color: ${({ theme }) => darken(0.07, theme.colors.primary)};
  }

  @media ${media.minWidth.sm} {
    width: ${spacing(10)};
    height: ${spacing(10)};
  }
  & svg {
    width: ${spacing(11)};
    height: ${spacing(11)};
  }

  &:hover svg {
    color: ${({ theme }) => darken(0.05, theme.colors.primary)};
  }
  &:active svg {
    transform: ${(props) => `scale(${props.theme.interactions.activeScale})`};
    opacity: 0.8;
  }
`;

export const $NeedHelpContainer = styled.div<NeedHelpPropsContainer>`
  right: 1%;
  bottom: ${({ $position }) => {
    if ($position === NEED_HELP_POSITION_TYPES.TOP) {
      return 'inherit';
    }

    return spacing(3.5);
  }};
  top: ${({ $position }) => {
    if ($position === NEED_HELP_POSITION_TYPES.BOTTOM) {
      return 'inherit';
    }

    return spacing(3.5);
  }};
  position: fixed;

  z-index: 10;

  & > div {
    display: block !important;
  }
`;
